import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from "@angular/core";
import { FilterModelDto } from "../../models/filter.model";
import { TerminalDataServiceService } from "./services/terminal-data-service.service";
import { TableHeightService } from "../../services/table-height.service";
import { debounceTime, Subscription } from "rxjs";
import { SortDataColumn } from "../../models/table.model";
import { SortTableService } from "../../services/sort-table.service";
import { TerminalModelsDto } from "./models/terminal.models";
import { ActivatedRoute, Router } from "@angular/router";
import { FilterSettingService } from "../../services/filter-setting.service";

@Component({
  selector: "app-terminal-list",
  templateUrl: "./terminal-list.component.html",
  styleUrls: ["./terminal-list.component.scss"],
})
export class TerminalListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("tableBlock") tableBlock: ElementRef | undefined;
  @ViewChild("tableBody") tableBody: ElementRef | undefined;
  @ViewChild("terminalBlock") terminalBlock: ElementRef | undefined;

  delta = 150;
  currentPage = 0;
  lastPage!: boolean;

  isOpenFilter = false;
  filterStatuses: FilterModelDto[] | undefined;
  filterBanks: FilterModelDto[] | undefined;

  terminalList: TerminalModelsDto[] = [];

  filterAdditional: FilterModelDto[] | undefined;

  subs: Subscription[] = [];

  sortColumnData: SortDataColumn | undefined;

  filterData: any;
  searchWord: string | undefined = "";

  constructor(
    private terminalDataService: TerminalDataServiceService,
    private tableHeightService: TableHeightService,
    private renderer: Renderer2,
    private sortTableService: SortTableService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private filterSettingService: FilterSettingService
  ) {}

  ngOnInit() {
    this.initFilter();
  }

  ngAfterViewInit() {
    this.subs.push(
      this.tableHeightService.tableHeight$.subscribe({
        next: (res) => {
          this.renderer.setStyle(this.tableBlock?.nativeElement, "height", res);
        },
      })
    );
  }

  ngOnDestroy() {
    this.subs.forEach((item) => item.unsubscribe());
    this.sortTableService.sortColum$.next(undefined);
  }

  loadTerminalList() {
    this.lastPage = true;
    this.terminalDataService.loadTerminals(this.currentPage, this.searchWord, this.filterData).subscribe({
      next: (res) => {
        this.terminalList.push(...res.content);
        this.currentPage++;
        this.lastPage = res.last;
      },
    });
  }

  onScroll(event: any): void {
    const tableBodyHeight = this.tableBody?.nativeElement.clientHeight;
    const tableBlockHeight = this.tableBlock?.nativeElement.clientHeight;
    const scrollTable = event.target.scrollTop;
    if (tableBodyHeight - tableBlockHeight - scrollTable < this.delta && !this.lastPage) {
      this.loadTerminalList();
    }
  }

  @HostListener("document:scroll", ["$event"])
  onWindowScroll(event: any): void {
    if (window.innerWidth <= 768) {
      if (this.terminalBlock?.nativeElement.clientHeight - window.scrollY - window.innerHeight + 120 < this.delta && !this.lastPage) {
        this.loadTerminalList();
      }
    }
  }

  initFilter() {
    this.subs.push(
      this.terminalDataService.loadTerminalFilter().subscribe({
        next: (res) => {
          this.filterAdditional = res["additional_params"];
          this.filterStatuses = res["statuses"];
          this.filterBanks = res["banks"];

          this.presetFilter();
        },
      })
    );

    this.subs.push(
      this.filterSettingService.filterSetData$.subscribe({
        next: (res) => {
          this.filterData = res;
          this.currentPage = 0;
          this.currentPage = 0;

          this.terminalList = [];
          this.loadTerminalList();
        },
      })
    );

    this.subs.push(
      this.filterSettingService.inputSearch$.pipe(debounceTime(300)).subscribe({
        next: (res) => {
          this.terminalDataService.loadSearchList(res).subscribe({
            next: (res) => {
              this.filterSettingService.responseSearchData$.next(res.content);
            },
          });
        },
      })
    );

    this.subs.push(
      this.filterSettingService.filterSearchWord$.subscribe({
        next: (res) => {
          this.searchWord = res;
        },
      })
    );

    this.subs.push(
      this.filterSettingService.filterAllReset$.subscribe({
        next: () => {
          this.searchWord = "";
          this.filterData = undefined;
          this.currentPage = 0;

          this.terminalList = [];
          this.loadTerminalList();
        },
      })
    );
  }

  presetFilter() {
    let params = [];
    if (this.activatedRoute.snapshot.queryParamMap.has("virtual_pos_id")) {
      params.push("virtual_pos_id");

      params.forEach((params) => {
        this.filterAdditional?.find((item) => item.fieldName === params);

        const filter: FilterModelDto = {
          fieldName: params,
          value: this.activatedRoute.snapshot.queryParamMap.get(params) ?? "",
          description: this.activatedRoute.snapshot.queryParamMap.get(params) ?? "",
        };

        const filterData = {
          virtual_pos_id: this.activatedRoute.snapshot.queryParamMap.get(params) ?? "",
        };

        this.isOpenFilter = true;

        this.sortColumnData = this.sortTableService.sort("IS_BLOCKED");

        const sort = `order=${this.sortColumnData?.order}&field=${this.sortColumnData?.field}`;
        this.sortTableService.sortColum$.next(sort);

        this.filterSettingService.filterSet$.next(filter);
        this.filterSettingService.filterSetData$.next(filterData);
      });
    } else {
      this.sortColumn("IS_BLOCKED");
    }
  }

  toggleFilter(filterState: boolean) {
    this.isOpenFilter = filterState;
  }

  sortColumn(column: string, isFirstCall = false) {
    this.sortColumnData = this.sortTableService.sort(column);

    const sort = `order=${this.sortColumnData?.order}&field=${this.sortColumnData?.field}`;
    this.sortTableService.sortColum$.next(sort);

    this.currentPage = 0;
    this.terminalList = [];
    this.loadTerminalList();
  }

  openPaymentForTerminal(id: string) {
    this.router.navigate(["/payment-list"], {
      queryParams: {
        terminal_id: id,
      },
    });
  }

  upload() {}
}
